/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Duration_PlaceholderInputs */

const en_search_duration_placeholder = /** @type {(inputs: Search_Duration_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search duration...`)
};

const es_search_duration_placeholder = /** @type {(inputs: Search_Duration_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar duracion...`)
};

/**
* | output |
* | --- |
* | "Search duration..." |
*
* @param {Search_Duration_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const search_duration_placeholder = /** @type {((inputs?: Search_Duration_PlaceholderInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Duration_PlaceholderInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_search_duration_placeholder(inputs)
	return es_search_duration_placeholder(inputs)
});